module.exports = __webpack_public_path__ + "static/home-equity-is-on-the-rise-4-e1faa4e75bb4fb9e09f2c20ccaedac8b.png";